// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jWei","largestCol":"styles_largestCol__1352t","smallestCol":"styles_smallestCol__SOAdI"};